import { useEffect } from "react";
import { useTenant } from "../../contexts/TenantContext";

const DynamicFavicon = () => {
  const { config } = useTenant();

  useEffect(() => {
    const faviconUrl =
      config?.branding?.favicon?.url || "/assets/images/favicon.ico";

    const link =
      (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconUrl;
    document.getElementsByTagName("head")[0].appendChild(link);
  }, [config?.branding?.favicon?.url]);

  return null;
};

export default DynamicFavicon;
